import { Link } from 'react-router-dom';
import type { Article } from '../lib/repo';
import { relativeTime } from '../lib/format';

export function ArticleCard({ article, variant = 'default' }: { article: Article; variant?: 'default' | 'lead' | 'compact' }) {
  const href = `/article/${article.slug}`;
  const meta = `${article.category?.name ?? ''}${article.publishedAt ? ' · ' + relativeTime(article.publishedAt) : ''}`;

  if (variant === 'compact') {
    return (
      <Link to={href} className="block py-3 hover:text-primary">
        <p className="text-xs uppercase tracking-wider text-muted">{article.category?.name}</p>
        <p className="mt-1 font-medium leading-snug">{article.title}</p>
        <p className="mt-1 text-xs text-muted">{relativeTime(article.publishedAt)}</p>
      </Link>
    );
  }

  if (variant === 'lead') {
    return (
      <article className="grid gap-6 md:grid-cols-2 md:items-center">
        <Link to={href} className="block overflow-hidden rounded-xl">
          <img src={article.coverImageUrl} alt={article.seo.ogImage ? article.title : ''} className="aspect-[16/10] w-full object-cover" loading="eager" width={800} height={500} />
        </Link>
        <div>
          <p className="text-xs uppercase tracking-widest text-primary">{article.category?.name}</p>
          <h2 className="mt-2 font-display text-3xl font-semibold leading-tight">
            <Link to={href} className="hover:text-primary">{article.title}</Link>
          </h2>
          <p className="mt-3 text-muted">{article.dek}</p>
          <p className="mt-4 text-xs uppercase tracking-wider text-muted">{meta}</p>
        </div>
      </article>
    );
  }

  return (
    <article className="group">
      <Link to={href} className="block overflow-hidden rounded-lg">
        <img src={article.coverImageUrl} alt="" className="aspect-[16/10] w-full object-cover transition group-hover:scale-[1.02]" loading="lazy" width={480} height={300} />
      </Link>
      <p className="mt-3 text-[11px] uppercase tracking-widest text-primary">{article.category?.name}</p>
      <h3 className="mt-1 font-display text-lg font-semibold leading-snug">
        <Link to={href} className="hover:text-primary">{article.title}</Link>
      </h3>
      <p className="mt-2 line-clamp-2 text-sm text-muted">{article.dek}</p>
      <p className="mt-2 text-[11px] uppercase tracking-wider text-muted">{meta}</p>
    </article>
  );
}
